import { API_URL } from '../constants/routes';
import { getRoute } from '../helpers/apiCalls';

export const metricsUser = async (data) => getRoute(`${API_URL}/metrics`, data);

export const latestTenants = async (data) => getRoute(`${API_URL}/tenant/all`, data);